<template>
  <div class="app-wrapper">
  <navbar></navbar>
  <div class="main-container">
    <LogoMobil></LogoMobil>
    <app-content></app-content>
  </div>
  </div>
</template>

<script>
import { Navbar, AppContent } from '@/containers/layouts/components'
import LogoMobil from '@/components/logo/logoMobil'

export default {
  name: 'AppLayout',
  components: {
    Navbar,
    AppContent, LogoMobil
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px
}
.main-container {
  padding: 20px;
  min-height: 86vh;
  background-color: #F8FDFF;
  
}
@media only screen and (max-width: 768px) {
  .main-container {
            padding: 10px 10px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/containers/layouts/appLayout.vue